import React, { useState } from 'react';
import styled from 'styled-components';
import { SimpleExhibitionData } from '../../../shared/dto/EntityRepository';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { useAdminExhibitionStore } from '../../share/store/adminExhibitionStore';

interface ExhibitionInfoProps {
  data: SimpleExhibitionData;
  isSelected: boolean;
  isMarqueeHit: boolean;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const ExhibitionInfo: React.FC<ExhibitionInfoProps> = ({
  data,
  isSelected,
  isMarqueeHit,
  handleClick,
}) => {
  const hasViewer = useAdminExhibitionStore((state) => (
    !!state.activeExhibition
    || state.multiSelectedExhibitionIds.length > 1
    || state.isBulkPreviewOpen
    || !!state.bulkResult
  ));
  const [hovered, setHovered] = useState(false);
  const isHover = hovered || isMarqueeHit;
  const artistNames = data.artists.map((artist) => artist.name).filter(Boolean).join(', ') || '-';

  return (
    <ExhibitionInfoComp
      data-exhibition-id={data.id}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <TitleBlock $isHover={isHover} $isActive={isSelected}>
        <TitleText>{data.title}</TitleText>
      </TitleBlock>
      <AdminBlockWithVisible
        width="1.4"
        value={data.venueCode}
        isHover={isHover}
        isActive={isSelected}
      />
      <AdminBlockWithVisible
        width="2"
        value={`${data.startDate} – ${data.endDate}`}
        isHover={isHover}
        isActive={isSelected}
      />
      <AdminBlockWithVisible
        width="2"
        value={artistNames}
        isHover={isHover}
        isActive={isSelected}
      />
      {hasViewer && <SpaceBlock />}
    </ExhibitionInfoComp>
  );
};

const ExhibitionInfoComp = styled.article`
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  min-height: 40px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
`;

const TitleBlock = styled.div<{ $isHover: boolean; $isActive: boolean }>`
  flex: 2.4;
  min-width: 0;
  display: flex;
  align-items: center;
  padding-left: 4px;
  text-decoration: ${({ $isActive }) => ($isActive ? 'underline' : 'none')};
  background-color: ${({ theme, $isHover, $isActive }) =>
    $isActive ? theme.colors.color_Gray_06 : $isHover ? theme.colors.color_Gray_07 : 'transparent'};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

const TitleText = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
`;

export default ExhibitionInfo;
